(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aquarium-product-dispatch"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const watched = new WeakSet();
    const init = () => {
      if (!desktop.matches || reducedMotion.matches || !('IntersectionObserver' in window)) return;
      document.querySelectorAll('.ae-pdp [data-ae-dispatch]').forEach(el => {
        if (watched.has(el)) return;
        watched.add(el);
        let inView = false;
        const play = () => {
          if (!inView || !desktop.matches || reducedMotion.matches || !el.querySelector('.ae-dispatch-desktop-card')) return;
          intersection.disconnect();
          mutations.disconnect();
          const finish = event => {
            if (event.animationName !== 'ae-dispatch-gentle-roll') return;
            el.classList.remove('ae-dispatch-truck-roll');
            el.removeEventListener('animationend', finish);
            el.removeEventListener('animationcancel', finish);
          };
          el.addEventListener('animationend', finish);
          el.addEventListener('animationcancel', finish);
          el.classList.add('ae-dispatch-truck-roll');
        };
        const mutations = new MutationObserver(play);
        const intersection = new IntersectionObserver(entries => {
          inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5);
          play();
        }, { threshold: 0.5 });
        mutations.observe(el, { childList: true, subtree: true });
        intersection.observe(el);
      });
    };
    desktop.addEventListener('change', init);
    reducedMotion.addEventListener('change', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["desktop-setup-variant-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const syncCard = card => {
      if (!desktop.matches || !card) return;
      const source = card.querySelector('[data-ae-desktop-setup-source]');
      const option = card.querySelector('[data-ae-setup-variant]')?.selectedOptions[0];
      const image = option?.dataset.aeDesktopSetupImage;
      if (source && image && source.getAttribute('srcset') !== image) source.setAttribute('srcset', image);
    };
    const syncAll = () => {
      if (desktop.matches) document.querySelectorAll('.ae-setup-card').forEach(syncCard);
    };
    document.addEventListener('change', event => {
      if (event.target.matches('[data-ae-setup-variant]')) syncCard(event.target.closest('.ae-setup-card'));
    });
    desktop.addEventListener('change', syncAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true });
    else syncAll();
    document.addEventListener('shopify:section:load', syncAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
